import { privateAxios } from 'services/api/privateAxios';

export const isCustomerBlocked = () =>
  privateAxios({
    method: 'post',
    url: '/customer/isblocked',
  });
